import React from 'react';
import { useLocation } from 'react-router-dom';
import { sendTrackingEvent } from 'src/utils/gtm';
import { PositionStatus } from 'types';

interface Props {
	tab: PositionStatus;
	setTab: (arg: PositionStatus) => void;
	activePositions?: number;
	closedPositions?: number;
}

const RecruiterPositionsTabsComponent = ({ tab, setTab, activePositions, closedPositions }: Props) => {
	const location = useLocation();
	return (
		<>
			<div className="flex w-full md:w-max dark:bg-[#1F2A37]">
				<button
					className={`${
						tab === PositionStatus.OPEN
							? 'bg-[#1C1C28] dark:bg-[#18222D] text-white'
							: 'bg-white dark:bg-gray-700 text-[#1C1C28] dark:text-gray-300 border-[#E4E4EB] dark:border-[#555770]'
					} !py-3 flex-1  text-center justify-center cursor-pointer !px-[2px] md:!px-4 max-h-fit leading-[20px] flex items-center border border-[#555770] border-solid rounded-l-[8px] font-inter sm:text-[14px] font-[500]`}
					onClick={() => {
						sendTrackingEvent({
							event: 'recr_dashboard_active',
							eventLabel: location.pathname,
						});
						setTab(PositionStatus.OPEN);
					}}
				>
					Active Positions ({activePositions})
				</button>
				<button
					className={` ${
						tab === PositionStatus.CLOSED
							? 'bg-[#1C1C28] dark:bg-[#18222D] text-white '
							: 'bg-white dark:bg-gray-700 text-[#1C1C28] dark:text-gray-300 border-[#E4E4EB] dark:border-[#555770]'
					} !py-3 sm:flex-1  text-center justify-center cursor-pointer !px-[2px] md:!px-4 max-h-fit leading-[20px] flex items-center border border-[#555770] border-solid rounded-r-[8px] font-inter sm:text-[14px] font-[500]`}
					onClick={() => {
						sendTrackingEvent({
							event: 'recr_dashboard_closed',
							eventLabel: location.pathname,
						});
						setTab(PositionStatus.CLOSED);
					}}
				>
					Closed Positions ({closedPositions})
				</button>
			</div>
		</>
	);
};

export default RecruiterPositionsTabsComponent;
